(function () {
    'use strict';

    angular.module('doclr.ipdc', ['doclr.resources.api', 'doclr.components.notification', 'ui.router'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('productcatalogus', {
                    url: '/productcatalogus/:productId',

                    resolve: {
                        producten: function (IpdcProducten, praktijkContext) {
                            return IpdcProducten.getList(praktijkContext.id).then(function (producten) {
                                return _.sortBy(producten, function (ipdcProduct) {
                                    if (ipdcProduct.product.naam && ipdcProduct.product.naam.nl) {
                                        return ipdcProduct.product.naam && ipdcProduct.product.naam.nl;
                                    }
                                    return "niet gekend";

                                });
                            });
                        },
                        ipdcProduct: function ($stateParams, producten) {
                            if ($stateParams.productId) {
                                return producten.filter(x => x.id === $stateParams.productId)[0] //EditableBeschikbaarheidTypes.load(decodeURIComponent(decodeURIComponent($stateParams.typeId)));
                            } else {
                                return producten[0];
                            }
                        }
                    },
                    views: {
                        '': {
                            templateUrl: '/partials/components/page.with.sidebar.large.margin.html',
                            controller: function ($scope, $state, $window) {
                                $scope.goToDetail = function (product) {
                                    $state.go('productcatalogus', {productId: product.id ? encodeURIComponent(encodeURIComponent(product.id)) : null}, {reload: true});
                                    $window.scroll({
                                        top: 0,
                                        behavior: 'smooth'
                                    });
                                };
                            }
                        },
                        'sidebar@productcatalogus': {
                            templateUrl: '/partials/ipdcproducts/producten.sidebar.html',
                            controller: function ($scope, $state, producten, ipdcProduct) {
                                $scope.producten = producten;
                                $scope.currentProduct = ipdcProduct;


                                $scope.isActiefProduct = function (product) {
                                    return $scope.currentProduct.id === product.id;
                                };

                                $scope.getNaam = function (ipdcProduct) {
                                    if (ipdcProduct.product.naam && ipdcProduct.product.naam.nl) {
                                        return ipdcProduct.product.naam && ipdcProduct.product.naam.nl;
                                    }
                                    return "niet gekend";
                                };


                            }
                        },
                        'content@productcatalogus': {
                            templateUrl: '/partials/ipdcproducts/producten.detail.html',
                            controller: function ($state,
                                                  $scope,
                                                  ipdcProduct,
                                                  $sce) {
                                $scope.ipdcProduct = ipdcProduct;
                                $scope.gg = 'ggbb'

                                $scope.naamTalen = Object.keys(ipdcProduct.product.naam);
                                $scope.naamSelection = {
                                    taal: $scope.naamTalen[0]
                                }

                                $scope.beschrijvingTalen = Object.keys(ipdcProduct.product.beschrijving);
                                $scope.beschrijvingSelection = {
                                    taal: $scope.beschrijvingTalen[0]
                                }

                            }
                        }
                    }

                });
        });
})();